import { render } from "./ViewFileModal.vue?vue&type=template&id=6757d3de&ts=true"
import script from "./ViewFileModal.vue?vue&type=script&lang=ts"
export * from "./ViewFileModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__